
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 8l-9 12H4l8-12h-.5zM17 8h-.5l3 12H21L17 8zm-3.5 2h.584l.416-2H14l-.5 2zm-1.125 4.5h.771l.729-3.5h-.625l-.875 3.5zM11 20h1l.938-4.5h-.813L11 20z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.229 8L1.5 20H3l8.729-12h-.5zM16.5 8H16l2.5 12H20L16.5 8zm-3.375 2h.584l.5-2h-.5l-.584 2zm-1.396 4.5h.771l1-3.5h-.625l-1.146 3.5zM10 20h1l1.25-4.5h-.813L10 20z","fill":"currentColor"}})])
          )
        }
      }
    